import clsx from "clsx";

interface TimerDisplayProps {
  className: string;
  value: number;
}

export default function TimerDisplay({ className, value }: TimerDisplayProps) {
  const mins = Math.floor(value / 60);
  const secs = Math.floor(value % 60);

  return (
    <span className={clsx("w-9 text-button-xs", className)}>
      {String(mins).padStart(2, "0")}:{String(secs).padStart(2, "0")}
    </span>
  );
}
